import { defineMessages } from "react-intl";

export const messages = defineMessages({
  newMessagesAvailableButtonLabel: {
    id: "button.newMessagesAvailable.label",
    defaultMessage: "New Messages Available",
    description: "Button when new messages available ",
  },
});
